(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-reviews-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ROOT_SELECTOR = '[data-rv]';
    var MAX_WAIT = 15000;

    function toArray(list) {
      return Array.prototype.slice.call(list);
    }

    // The theme already ships Flickity. It may load after this script, so wait for it.
    function whenFlickity(callback) {
      if (window.Flickity) {
        callback();
        return;
      }
      var waited = 0;
      var timer = setInterval(function () {
        waited += 100;
        if (window.Flickity) {
          clearInterval(timer);
          callback();
        } else if (waited >= MAX_WAIT) {
          clearInterval(timer);
        }
      }, 100);
    }

    function equalizeHeights(slides) {
      var max = 0;
      var i;
      for (i = 0; i < slides.length; i++) {
        slides[i].style.height = '';
      }
      for (i = 0; i < slides.length; i++) {
        max = Math.max(max, slides[i].offsetHeight);
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.height = max + 'px';
      }
    }

    function positionArrows(root, slides) {
      var media = slides[0] ? slides[0].querySelector('[data-rv-media]') : null;
      if (media) {
        root.style.setProperty('--rv-arrow-top', media.offsetTop + media.offsetHeight / 2 + 'px');
      } else {
        root.style.setProperty('--rv-arrow-top', '50%');
      }
    }

    function updateUI(root, flkty) {
      var many = flkty.slides && flkty.slides.length > 1;
      var loop = root.getAttribute('data-loop') === 'true';
      var prev = root.querySelector('[data-rv-prev]');
      var next = root.querySelector('[data-rv-next]');

      root.classList.toggle('rv--static', !many);

      if (prev) {
        prev.disabled = !loop && flkty.selectedIndex <= 0;
      }
      if (next) {
        next.disabled = !loop && flkty.selectedIndex >= flkty.slides.length - 1;
      }
    }

    function refresh(root) {
      var instance = root.__rv;
      if (!instance) {
        return;
      }
      equalizeHeights(instance.slides);
      instance.flkty.resize();
      positionArrows(root, instance.slides);
      updateUI(root, instance.flkty);
    }

    function setup(root) {
      if (root.__rv || root.__rvPending) {
        return;
      }
      var slider = root.querySelector('[data-rv-slider]');
      if (!slider) {
        return;
      }
      var slides = toArray(slider.querySelectorAll('[data-rv-slide]'));
      if (!slides.length) {
        return;
      }

      root.__rvPending = true;

      whenFlickity(function () {
        root.__rvPending = false;
        if (root.__rv || !document.body.contains(root)) {
          return;
        }

        var reduceMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var autoplay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;

        equalizeHeights(slides);

        var flkty = new window.Flickity(slider, {
          cellSelector: '[data-rv-slide]',
          cellAlign: 'left',
          contain: true,
          wrapAround: root.getAttribute('data-loop') === 'true',
          groupCells: root.getAttribute('data-group') === 'true',
          prevNextButtons: false,
          pageDots: root.getAttribute('data-dots') === 'true',
          draggable: '>1',
          percentPosition: false,
          adaptiveHeight: false,
          autoPlay: autoplay && !reduceMotion ? autoplay : false,
          pauseAutoPlayOnHover: true
        });

        root.__rv = { flkty: flkty, slides: slides };

        var prev = root.querySelector('[data-rv-prev]');
        var next = root.querySelector('[data-rv-next]');
        if (prev) {
          prev.addEventListener('click', function () {
            flkty.previous();
          });
        }
        if (next) {
          next.addEventListener('click', function () {
            flkty.next();
          });
        }

        flkty.on('select', function () {
          updateUI(root, flkty);
        });

        positionArrows(root, slides);
        updateUI(root, flkty);
      });
    }

    function initAll(scope) {
      toArray((scope || document).querySelectorAll(ROOT_SELECTOR)).forEach(setup);
    }

    function refreshAll() {
      toArray(document.querySelectorAll(ROOT_SELECTOR)).forEach(refresh);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refreshAll, 150);
    });

    window.addEventListener('load', refreshAll);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshAll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    // Theme editor support
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      toArray(event.target.querySelectorAll(ROOT_SELECTOR)).forEach(function (root) {
        if (root.__rv) {
          root.__rv.flkty.destroy();
          root.__rv = null;
        }
      });
    });

    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target;
      var root = slide.closest ? slide.closest(ROOT_SELECTOR) : null;
      if (!root || !root.__rv) {
        return;
      }
      var index = root.__rv.slides.indexOf(slide);
      if (index > -1) {
        root.__rv.flkty.stopPlayer();
        root.__rv.flkty.select(index);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
